var map;
var toggleableLayerGroups = [
  [ ['aspect','Aspect'], ['slope','Slope'], ['soils','Soils']],
  [ ['contours100',"100' Contours"]],
  [ ['contours20',"20' Contours"] ]
];

var legendDataAspect = [
  ['Flat', '#ececec'],
  ['North', '#fe6667'],
  ['Northeast', '#ffc86a'],
  ['East', '#feff66'],
  ['Southeast', '#6cfd6e'],
  ['South', '#66ffff'],
  ['Southwest', '#67c1ed'],
  ['West', '#6666fe'],
  ['Northwest', '#fd66ff']
];

var legendDataSlope = [
  ['0 - 6', '#80b0d3'],
  ['6 - 12', '#cde8f2'],
  ['12 - 18', '#ffffd9'],
  ['18 - 24', '#fecea0'],
  ['> 24', '#e77577']
];

var legendDataSoils = [
  ['68883', '#7aa9da'],
  ['68884', '#737cc9'],
  ['68885', '#bcc0f0'],
  ['68886', '#212fed'],
  ['68887', '#212fed'],
  ['68979', '#e8b081'],
  ['68980', '#8b7054'],
  ['69002', '#24791e'],
  ['69003', '#5bd457'],
  ['69024', '#e8c01f'],
  ['69035', '#c8d178'],
  ['69055', '#e03e33'],
  ['69057', '#f46b74'],
  ['69072', '#5a76e6']
];

$(document).ready(function() {

  if ($("#map").length){

    // Handle Video Carousel auto-pause on slide
    $('#videosCarousel').on('slide.bs.carousel', function () {
      productPauseVideos();
    });
    // Handle arrival on new video
    $('#videosCarousel').on('slid.bs.carousel', function () {
        // Pause carousel
        $('#videosCarousel').carousel('pause');
    });
    // Handle Video modal closing (pause)
    $('#videosModal').on('hide.bs.modal', function (e) {
      productPauseVideos();
    })


    map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/satellite-streets-v9',
        center: [-120.082458,46.506761],
        zoom: 12,
        scrollZoom: false,
    });

    map.on('style.load', function () {
      initializeMapLayers();

    });

    map.on('load', function () {

      // Add zoom and rotation controls to the map.
      map.addControl(new mapboxgl.NavigationControl(), 'top-left');

      // Base Layers
      $(".menubase a").click(function(){
        map.setStyle('mapbox://styles/mapbox/' + $(this).attr('data-layer'));
        $(this).siblings().each(function( index ){
          $(this).removeClass('active');
        });
        $(this).addClass('active');

      });


      // Set up toggles
      for (var g = 0; g < toggleableLayerGroups.length; g++) {

        var menu = $("<div></div>").addClass("menu menulayers");

        for (var i = 0; i < toggleableLayerGroups[g].length; i++) {

          var id = toggleableLayerGroups[g][i][0];

          var link = $("<a class='' data-layer='"+toggleableLayerGroups[g][i][0]+"'>"+toggleableLayerGroups[g][i][1]+"</a>");

          link.click(function(e){

            e.preventDefault();
            e.stopPropagation();

            if ($(this).hasClass('active')){
              $(this).removeClass('active');

            }else{
              // get siblings
              $(this).siblings().each(function( index ){

                $(this).removeClass('active');

              });

              $(this).addClass('active');
            }



            toggleMapLayers();

          });

          menu.append(link);
          $("#menus").append(menu);

        }
      }

      initializeMapLegends();

    });


  }

});


function initializeMapLayers(){


    // Aspect
    if (!map.getSource("aspect")) {
      map.addSource('aspect', {
          'type': 'geojson',
          data: aspectURL
      });
    }
    map.addLayer({
        'id': 'aspect',
        'type': 'fill',
        'source': 'aspect',
        'layout': {
          'visibility': 'none'
        },
        "paint": {
          'fill-color': {
           property: 'aspect',
           'type': 'categorical',
           stops: legendDataAspect
         },
         'fill-opacity':0.9
        }

    });

    // Slope
    if (!map.getSource("slope")) {
      map.addSource('slope', {
          'type': 'geojson',
          data: slopeURL
      });
    }
    map.addLayer({
        'id': 'slope',
        'type': 'fill',
        'source': 'slope',
        'layout': {
          'visibility': 'none'
        },
        "paint": {
          'fill-color': {
           property: 'pct_slope',
           'type': 'categorical',
           stops: legendDataSlope
         },
         'fill-opacity':0.9
        }

    });

    // Soils
    if (!map.getSource("soils")) {
      map.addSource('soils', {
          'type': 'geojson',
          data: soilsURL
      });
    }
    map.addLayer({
        'id': 'soils',
        'type': 'fill',
        'source': 'soils',
        'layout': {
          'visibility': 'none'
        },
        "paint": {
          'fill-color': {
           property: 'MUKEY',
           'type': 'categorical',
           stops: legendDataSoils
         },
         'fill-opacity':0.9
        }

    });

    // Contours 100
    if (!map.getSource("contours100")) {
      map.addSource('contours100', {
          'type': 'geojson',
          data: contours100URL
      });
    }
    map.addLayer({
        'id': 'contours100',
        'type': 'line',
        'source': 'contours100',
        'layout': {
          'visibility': 'none'
        },
        "paint": {
            "line-color": "#ffffff",
            "line-width": 2
        }
    });

    // Contours 20
    if (!map.getSource("contours20")) {
      map.addSource('contours20', {
          'type': 'geojson',
          data: contours20URL
      });
    }
    var aspectLayer = map.addLayer({
        'id': 'contours20',
        'type': 'line',
        'source': 'contours20',
        'layout': {
          'visibility': 'none'
        },
        "paint": {
            "line-color": "#efefef",
            "line-width": 1
        }
    });


    // Property Boundary
    if (!map.getSource("property")) {
      map.addSource("property", {
           "type": "geojson",
           data: propertyURL,
       });
    }
    map.addLayer({
        "id": "property",
        "type": "line",
        "source": "property",
        "layout": {},
        "paint": {
            "line-color": "#e23e21",
            "line-width": 4
        }
    });


    toggleMapLayers();
}

function initializeMapLegends(){

    // Aspect
    var tempLegend = "<div id='legend-aspect' class='legend'><h6>Aspect</h6>";
    for (var i = 0; i < legendDataAspect.length; i++) {
      tempLegend += "<div><span style='background-color: "+legendDataAspect[i][1]+"'></span>"+legendDataAspect[i][0]+"</div>";
    }
    tempLegend += "</div>";
    //console.log(tempLegend);
    $("#legends").append(tempLegend);

    // Slope
    var tempLegend = "<div id='legend-slope' class='legend'><h6>Slope</h6>";
    for (var i = 0; i < legendDataSlope.length; i++) {
      tempLegend += "<div><span style='background-color: "+legendDataSlope[i][1]+"'></span>"+legendDataSlope[i][0]+"</div>";
    }
    tempLegend += "</div>";
    //console.log(tempLegend);
    $("#legends").append(tempLegend);

    // Soils
    var tempLegend = "<div id='legend-soils' class='legend'><h6>Soils</h6>";
    for (var i = 0; i < legendDataSoils.length; i++) {
      tempLegend += "<div><span style='background-color: "+legendDataSoils[i][1]+"'></span>"+legendDataSoils[i][0]+"</div>";
    }
    tempLegend += "</div>";
    //console.log(tempLegend);
    $("#legends").append(tempLegend);

}

function toggleMapLayers(){

  $(".menulayers").each(function(){

    $(this).children('a').each(function(){

      var thisLayerID = $(this).attr('data-layer');

      var visibility = map.getLayoutProperty(thisLayerID, 'visibility');

      if ($(this).hasClass('active') && visibility !== 'visible') {
          map.setLayoutProperty(thisLayerID, 'visibility', 'visible');

          $("#legend-"+thisLayerID).show();

      } else if (!$(this).hasClass('active') && visibility === 'visible') {

          map.setLayoutProperty(thisLayerID, 'visibility', 'none');

          // Legends Check
          $("#legend-"+thisLayerID).hide();

      }


    });

  });

}

function productPauseVideos(){

  // Pause all videos
  $(".video").each(function(){

    var tempSrc = $(this).attr("src");
    tempSrc = tempSrc.replace("&autoplay=false", "");
    tempSrc = tempSrc.replace("&autoplay=true", "");
    $(this).attr("src",tempSrc);

  });

}



// WEBPACK FOOTER //
// ./resources/assets/js/public/home.js